import React from "react";
import { Link } from "react-router-dom";
import logoElakay from "../../Layout/icon/logoelakayDiamant-256.png";

export default function GroupInvitationHeader({ eyebrow = "Group Invitations", compact = false }) {
  return (
    <header className={`gi-site-header${compact ? " gi-site-header--compact" : ""}`}>
      <Link className="gi-brand" to="/" aria-label="Elakay — accueil">
        <img src={logoElakay} alt="" />
        <span><strong>ELAKAY</strong><small>{eyebrow}</small></span>
      </Link>
      {!compact && <Link className="gi-home-link" to="/">Accueil</Link>}
    </header>
  );
}
